export function dictionary(text){
    let lang = 'fa';
    let dic = {
        fa:{
            'سفارش غذا':'سفارش غذا',
            'سبد خرید':'سبد خرید',
            'سفارش ها':'سفارش ها',
            'ارتباط آنلاین':'ارتباط آنلاین',
            'پروفایل':'پروفایل',
            'پنل ادمین':'پنل ادمین',
            '':'',
            '':'',
            '':'',
            '':'',
            '':'',
            '':'',
            '':'',
            '':'',
            '':'',
            '':'',
            '':'',
            '':'',
            '':'',
            '':'',
            '':'',
            '':'',
            '':'',
            '':'',
            '':'',
            '':'',
            '':'',

        }
    }
    let res = dic[lang][text];
    return res
}